import { render, staticRenderFns } from "./StoriesMoreCredit.vue?vue&type=template&id=78f007d7&scoped=true&"
import script from "./StoriesMoreCredit.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreCredit.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreCredit.vue?vue&type=style&index=0&id=78f007d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f007d7",
  null
  
)

export default component.exports